import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GenericHandoverContent from './content/genericHandoverContent';
import addHandoverWrapper from './handoverWrapper';

class GenericHandover extends React.Component {
	render() {
		const report = this.props.report.data[0];
		
		return (
			<GenericHandoverContent report={report} />
		);
	}
}

GenericHandover.propTypes = {
	context: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	report: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
	context: state.context
});

export default connect(
	mapStateToProps
)(addHandoverWrapper(
	GenericHandover, {
		title: '',
		className: 'generic-handover'
	})
);
